import {
  PumpSuspendReason,
  ActivityType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "components.activity_name."
interface Props {
  activityType: ActivityType;
  suspendReason?: PumpSuspendReason;
}

export function ActivityName(props: Props) {
  const polyglot = usePolyglot()

  const localizationKey = useMemo(
    () => {
      switch (props.activityType) {
        case ActivityType.Bolus:
          return `${polyglotPrefix}bolus`
        case ActivityType.CGMSessionEnded:
          return `${polyglotPrefix}cgm_session_ended`
        case ActivityType.DeviceChange:
          return `${polyglotPrefix}device_change`
        case ActivityType.Exercise:
          return `${polyglotPrefix}exercise`
        case ActivityType.Food:
          return `${polyglotPrefix}food`
        case ActivityType.Glucose:
          return `${polyglotPrefix}glucose`
        case ActivityType.Liquid:
          return `${polyglotPrefix}liquid`
        case ActivityType.Insulin:
          return `${polyglotPrefix}insulin`
        case ActivityType.Medication:
          return `${polyglotPrefix}medication`
        case ActivityType.Note:
          return `${polyglotPrefix}note`
        case ActivityType.PumpSuspension:
          switch (props.suspendReason) {
            case PumpSuspendReason.BIQSuspend:
              return `${polyglotPrefix}pump_suspension.basal_iq_suspension`
            case PumpSuspendReason.CIQSuspend:
              return `${polyglotPrefix}pump_suspension.control_iq_suspension`
            default:
              return `${polyglotPrefix}pump_suspension.all_deliveries_stopped`
          }
        default:
          return `${polyglotPrefix}unknown`
      }
    },
    [
      props.activityType,
      props.suspendReason,
    ],
  )

  return (
    <div id={`${props.activityType}-graph-icon`}>
      {polyglot.t(localizationKey)}
    </div>
  )
}
